export function P({ children, ...props }: React.ComponentProps<"p">) {
  return (
    <p className="w-p mx-auto" {...props}>
      {children}
    </p>
  );
}

export function Ol({ children, ...props }: React.ComponentProps<"ol">) {
  return (
    <ol className="w-p mx-auto" {...props}>
      {children}
    </ol>
  );
}

export function Ul({ children, ...props }: React.ComponentProps<"ul">) {
  return (
    <ul className="w-p mx-auto" {...props}>
      {children}
    </ul>
  );
}
